import classNames from "classnames";
import { useHistory, useLocation } from "react-router-dom";

import { Icon } from "src/app/components/icon/Icon";
import { ProjectSystem } from "src/app/modules/calculator/types";
import { ROUTES } from "src/config/constants";
import { ProjectResponse } from "src/core/models/projects/ProjectResponse";

import calonCss from "../calculator/components/calculation/Calculation.module.css";
import projectCss from "./Projects.module.css";

function Header({ userId, project, selectedSystems }: { userId: number; project: ProjectResponse; selectedSystems: Array<ProjectSystem> }) {
  const history = useHistory();
  const location = useLocation();
  const isAdminLocation = location.pathname.includes("admin");

  return (
    <div>
      <div className={classNames(projectCss.projectHeader)}>
        <div className={classNames("u-flex", "u-flex-content-start", "u-flex-items-center", calonCss.backBtnContainer)}>
          <button
            onClick={() => {
              isAdminLocation ? history.goBack() : history.push(ROUTES.showUserProjects(userId));
            }}
            className="u-t-primary-dark u-cursor-pointer u-t-uppercase u-t-f16p u-t-lh15 u-font-family-inh u-t-nodecoration u-t-w400"
          >
            Nazad na sve projekte
          </button>
        </div>
        <h2 className="u-t-primary u-t-align-center">
          Upit {project.id} - {project.name}
        </h2>
      </div>
      <div className={classNames("u-flex", projectCss.headerMobileSub)}>
        <div className="u-col-12 u-flex u-flex-items-center u-t-success">
          <Icon name="accept" className="u-t-f22p u-t-success"></Icon>
          <span className="u-ml15px u-t-f18p">{project.partnerName ? "Upit poslan partneru " + project.partnerName : "Izračun spremljen."}</span>
        </div>
        <div className="u-col-12">
          <h3>Potrebni materijali za sve odabrane sustave</h3>
        </div>
      </div>
    </div>
  );
}

export default Header;
